import { animateScroll } from 'react-scroll';

const noop = () => {}

function createDecorator(form) {
    const scrollToFirstError = errors => {
        setTimeout(() => {
            const elements = document.getElementsByClassName(`scroll-to-error`);
            if (elements.length) {
                animateScroll.scrollTo(getOffset(elements[0]).top - 115);
            }
        }, 200)
    }

    const getOffset = el => {
        const rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    }

    // Save original submit function
    const originalSubmit = form.submit

    let state = {errors: {}};
    const unsubscribe = form.subscribe(
        nextState => {state = nextState},
        {errors: true}
    )

    // What to do after submit
    const afterSubmit = () => {
        const { errors } = state
        scrollToFirstError(errors);
    }

    // Rewrite submit function
    form.submit = () => {
        const result = originalSubmit.call(form)
        if (result && typeof result.then === 'function') {
            // async
            result.then(afterSubmit, noop)
        } else {
            // sync
            afterSubmit()
        }
        return result
    }

    return () => {
        unsubscribe()
        form.submit = originalSubmit
    }
}

export default createDecorator